var _path, _path2, _rect, _rect2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgJersey(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.3805 1.75781L15.4835 0.309297C15.0788 0.106953 14.6257 0 14.1733 0H5.82672C5.3743 0 4.92125 0.106953 4.51652 0.309297L1.61945 1.75781C0.620547 2.2573 0 3.26137 0 4.3782V9.375H3.51562V20H16.4844V9.375H20V4.3782C20 3.26137 19.3795 2.2573 18.3805 1.75781ZM18.8281 8.20312H16.4844V5.85938H15.3125V18.8281H4.6875V5.85938H3.51562V8.20312H1.17188V4.3782C1.17188 3.70809 1.54422 3.10566 2.14355 2.80598L5.04059 1.35746C5.2834 1.23605 5.55527 1.17188 5.82672 1.17188H14.1733C14.4447 1.17188 14.7166 1.23605 14.9594 1.35746L17.8564 2.80598C18.4558 3.10566 18.8281 3.70809 18.8281 4.3782V8.20312Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.7578 2.34375H8.24219V3.51562H11.7578V2.34375Z",
    fill: "white"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 4.1665,
    y: 10.8333,
    width: 11.6667,
    height: 1.16667,
    fill: "white"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 4.1665,
    y: 14.1667,
    width: 11.6667,
    height: 1.16667,
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgJersey);
export default __webpack_public_path__ + "static/media/jersey.5fc55260aa8cf8b656dccf7f6a110ba9.svg";
export { ForwardRef as ReactComponent };